const DEFAULT_WEBSITE_ORIGIN = 'https://clickorico.fr';

/**
 * Origine du site client (parcours réservation / fiche commerçant).
 * - VITE_WEBSITE_ORIGIN si défini (prod ou lab)
 * - localhost:3002 en dev admin (vite) uniquement — branch morte en build prod
 * - clickorico.fr sinon
 */
export function resolveWebsiteOrigin() {
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_WEBSITE_ORIGIN) {
    return String(import.meta.env.VITE_WEBSITE_ORIGIN).replace(/\/$/, '');
  }
  if (typeof import.meta !== 'undefined' && import.meta.env?.DEV) {
    return 'http://localhost:3002';
  }
  return DEFAULT_WEBSITE_ORIGIN;
}

const PROFESSIONALS_PUBLIC_PATH = '/professionnels';

/**
 * URL publique fixe de la page Professionnels.
 * Origine = même source que le reste de l'Admin (VITE_WEBSITE_ORIGIN).
 * La route n'est pas éditable.
 */
export function buildProfessionalsPublicUrl(origin = resolveWebsiteOrigin()) {
  return `${String(origin || '').replace(/\/$/, '')}${PROFESSIONALS_PUBLIC_PATH}`;
}

/**
 * URL page publique commerçant sur le site client de l'environnement courant
 * (VITE_WEBSITE_ORIGIN en préprod / prod — jamais www en dur).
 * @param {object} commercant
 */
export function buildCommercantPublicUrl(commercant) {
  const slug = commercant?.slug || commercant?.id;
  return `${resolveWebsiteOrigin()}/${slug}`;
}

/**
 * Lien réservation test directe (parcours client existant, query params).
 * @param {object} commercant
 * @param {string} prestationId
 */
export function buildReservationTestUrl(commercant, prestationId) {
  const params = new URLSearchParams({
    commercantId: commercant?.id || '',
    prestationId: prestationId || '',
  });
  return `${resolveWebsiteOrigin()}/rendez-vous?${params.toString()}`;
}
